import isEmpty from 'lodash/isEmpty.js';
import { Logger } from '~~/helpers/logger';
import { getFirstCookieValue } from '~~/helpers/cookies/getFirstCookieValue';
import type { CiaDependencies } from '~/composables/useCia/types';
import { BLOOMREACH_COOKIE } from '~~/constants/bloomreach';

export interface ConsentProps {
  newsletter?: boolean;
  phone?: boolean;
  sms?: boolean;
  soft_newsletter?: boolean;
  soft_phone?: boolean;
  soft_sms?: boolean;
}

type ConsentParams = {
  consents: ConsentProps;
  gdprPhone?: string;
  additionalProps?: object;
  emailToken?: string;
  userId?: string;
  hash?: string;
};

type ConsentRequest = {
  locale: string;
  consents: ConsentProps;
  cookie?: string;
  additional_props: object;
  email_token?: string;
  gdpr_phone?: string;
  user_id?: string;
  email?: string;
};

export default (dependencies: CiaDependencies) => {

  const { fetch, cookies, languageAndCountry } = dependencies;

  return async ({
    consents,
    gdprPhone = '',
    additionalProps = {},
    emailToken = '',
    userId,
  }: ConsentParams): Promise<unknown> => {

    if (import.meta.server) {

      if (import.meta.dev) {

        Logger.debug('cia|consent SSR suppressed');

      }

      return Promise.resolve();

    }

    if (isEmpty(consents)) {

      return Promise.resolve();

    }

    const bloomreachCookieValue = getFirstCookieValue(cookies?.get(BLOOMREACH_COOKIE));

    const payload: ConsentRequest = {
      locale: languageAndCountry,
      consents,
      cookie: bloomreachCookieValue,
      additional_props: additionalProps,
    };

    if (gdprPhone) {

      payload.gdpr_phone = gdprPhone.replace(/\s+/g, '');

    }

    if (emailToken) {

      payload.email_token = emailToken;

    }

    if (userId) {

      payload.user_id = userId;

    }

    return fetch('/cia/consent', {
      method: 'POST',
      body: payload,
    });

  };

};
